import './organization-detail-row.scss';
import type React from 'react';

interface Props {
  label: string;
  value: string;
  children?: React.ReactNode;
  testId?: string;
}

export function OrganizationDetailRow({ label, value, children, testId }: Props) {
  return (
    <div className={`label-value-row org-detail-row-${label}`} data-testid={testId}>
      <p className="label">{label}</p>

      {value && <p className="value">{value}</p>}

      {children && <div className="value__children">{children}</div>}
    </div>
  );
}
